import React from 'react';
import { string, bool } from 'prop-types';
import styled, { css } from 'styled-components';

import Avatar from '../../../common/Avatar';


const Container = styled.div`
    display: flex;
    align-items: center;
`;

const Name = styled.div`
    font-weight: bold;
`;

const small_avatar = css`
    width: 30px;
    height: 30px;
`;

const StyledAvatar = styled(Avatar)`
    ${({ small }) => small && small_avatar };
`;


const AuthorItem = ({
    name,
    logo_url,
    small,
    className,
}) => (
    <Container className={className}>
        <StyledAvatar src={logo_url} small={small} />
        <Name>{ name }</Name>
    </Container>
);

AuthorItem.propTypes = {
    name: string.isRequired,
    logo_url: string.isRequired,
    small: bool,
    className: string,
};

AuthorItem.defaultProps = {
    small: false,
};

export default AuthorItem;
